import { useToast } from '@repo/design-system/index'
import { QIcon_search_default } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import apis from '../../../modules/apis'
import { axiosGet, axiosPost } from '../../../modules/axiosHelper'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useWebviewNavigation from '../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_upcoming_lessons } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import {
  BottomFixedSection,
  PREV_TWO_HOUR_FROM_LESSON,
  SelectMaterial,
  SelectMaterialProvider,
} from '../../../pages/[lang]/portal/lessons/materials/[lessonId]'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface IMaterialSelect {
  params: {
    lessonId: string
    materialId: string | null
    type: string | null
  }
}

const LessonMaterialChangeActivity: ActivityComponentType = ({ params }: IMaterialSelect) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop, push, replace } = useLessonsFlow()
  const { toastError, toastSuccess } = useToast()
  const { t } = useTranslation()
  const router = useAppRouter()
  const { popBackToRingleApp } = useWebviewNavigation()
  const [diffHours, setDiffHours] = useState(10)
  // 교재 저장 버튼
  const handleClickSaveMaterial = async (lessonId, materialId) => {
    try {
      if (!materialId) {
        toastError(t(n_upcoming_lessons.edit_materials.tab_desc))

        return
      }

      const response = await axiosPost(apis.lessons.editCourse(), {
        lesson_id: lessonId,
        course_id: materialId,
      })

      if (response.success) {
        toastSuccess(t(n_upcoming_lessons.edit_materials.toast_change))
        if (params?.type == 'schedule') {
          router.appScreenReset({
            appScreenName: APP_SCREEN_NAME.MAIN_TABS,
          })
        } else {
          popBackToRingleApp()
        }
      } else {
        pop()
      }
    } catch (e) {
      alert(e.message)
    }
  }

  const fetchLessonInfo = async (lessonId) => {
    const response = await axiosGet(apis.lessons.upcoming(lessonId))

    if (response) return response.data
  }

  const onClickSearch = () => {
    push('LessonMaterialSearchActivity', {
      lessonId: params.lessonId,
      materialId: params.materialId,
    })
  }

  const { data: lessonInfoData, isFetching }: any = useQuery({
    queryKey: ['lesson_data', router.query.lessonId],
    queryFn: () => fetchLessonInfo(router.query.lessonId),
  })

  useEffect(() => {
    if (lessonInfoData && !isFetching) {
      setDiffHours(lessonInfoData?.lesson?.diff_hours)
    }
  }, [lessonInfoData, isFetching])

  return (
    <>
      <SelectMaterialProvider>
        <WebviewStackContainer
          title={params.materialId ? t(n_upcoming_lessons.menu_option3_2) : t(n_upcoming_lessons.menu_option3)}
          onBack={pop}
          appendRight={() => {
            if (diffHours > PREV_TWO_HOUR_FROM_LESSON)
              return (
                <button className="px-20" onClick={onClickSearch}>
                  <QIcon_search_default width={24} height={24} />
                </button>
              )
          }}
        >
          <div className="relative">
            <div className="px-[16px]">
              <SelectMaterial />
            </div>
            <BottomFixedSection lessonId={params.lessonId} handleClickSaveMaterialWebview={handleClickSaveMaterial} />
          </div>
        </WebviewStackContainer>
      </SelectMaterialProvider>
    </>
  )
}

export default LessonMaterialChangeActivity
